  document.addEventListener('DOMContentLoaded', function() {
    const swiper1 = new Swiper('.swiper-image-and-link', {
      loop: true,
      spaceBetween: 0,
      allowTouchMove: false,
    });

    const swiper2 = new Swiper('.swiper-text-and-contributor', {
      loop: true,
      spaceBetween: -2,
      allowTouchMove: false,
    });

    // Shared Navigation Controls
    document.getElementById('nextBtnDesktop').addEventListener('click', () => {
      swiper1.slideNext();
      swiper2.slideNext();
    });

    document.getElementById('prevBtnDesktop').addEventListener('click', () => {
      swiper1.slidePrev();
      swiper2.slidePrev();
    });

    document.getElementById('nextBtnMobile').addEventListener('click', () => {
      swiper1.slideNext();
      swiper2.slideNext();
    });

    document.getElementById('prevBtnMobile').addEventListener('click', () => {
      swiper1.slidePrev();
      swiper2.slidePrev();
    });
  });